import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Upload = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("polygon", { points: "17.414,6.207 12,0.793 6.586,6.207 8,7.621 11,4.621 11,18.207 13,18.207 13,4.621 16,7.621" }),
    React.createElement("polygon", { points: "23.31,23.207 0.69,23.207 4.236,10.207 8,10.207 8,12.207 5.764,12.207 3.31,21.207 20.69,21.207 18.236,12.207 16,12.207 16,10.207 19.764,10.207" })), 'Upload');
export default Upload;
